import { createSelector } from 'reselect';
import { flow, max, values } from 'lodash/fp';

import getAgrAgeBracketFromAge from '../../utils/get-agr-age-bracket-from-age';
import selectCustomerAges, { MemberYouthDiscountAgesType } from '../select-youth-discount-ages';

const getAgrBracketFromAges = (ages: MemberYouthDiscountAgesType) =>
  getAgrAgeBracketFromAge(flow(values, max)(ages) || 0);

const selectAgeBracket = createSelector(selectCustomerAges, getAgrBracketFromAges);

export default selectAgeBracket;

export type AgeBracket = string;

export { getAgrBracketFromAges };
